import React, { Component, Fragment } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';
import { DatePickerField, CheckboxField } from 'Common/SemanticWrapper';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { RECEIPTS_COLLECTIONS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { ReceiptsAndCollectionsReportFieldEnum as Fields } from 'Common/FieldEnum';

class ReceiptsAndCollectionsReportFormContainer extends Component {
  feedingOptions = [
    { value: 0, label: 'Breakfast / Lunch / Other' },
    { value: 1, label: 'Supper' },
  ];

  displayOrigValuesField = () => {
      return (
        <Field
          label={'Print Original Values'}
          name={Fields.PrintOriginalValues}
          component={CheckboxField}
        />
      );
   
  };

  render() {
    return (
      <Fragment>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <ReduxFormButtonGroup
                label={'Meal Type'}
                options={this.feedingOptions}
                formName={RECEIPTS_COLLECTIONS_REPORT_FORM_NAME}
                value={this.props.formValues[Fields.FeedingType]}
                fieldName={Fields.FeedingType}
                disabled={false}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Field
                label={'From Date'}
                name={Fields.FromDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                label={'To Date'}
                name={Fields.ToDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                label={'Summary Only'}
                name={Fields.SummaryOnly}
                component={CheckboxField}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>{this.displayOrigValuesField()}</Grid.Column>
          </Grid.Row>
        </Grid>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }

  if (
    !moment(values[Fields.ToDate]).isSame(values[Fields.FromDate]) &&
    values[Fields.FromDate]
  ) {
    if (!moment(values[Fields.ToDate]).isAfter(values[Fields.FromDate])) {
      errors[Fields.ToDate] = 'To Date must be equal or after From Date.';
    }
  }

  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(RECEIPTS_COLLECTIONS_REPORT_FORM_NAME)(state),
    validate,
  };
};

const ReceiptsAndCollectionsReportForm = reduxForm({
  form: RECEIPTS_COLLECTIONS_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(
      mapStateToProps,
      {}
    )(ReceiptsAndCollectionsReportFormContainer)
  )
);

export { ReceiptsAndCollectionsReportForm };



// WEBPACK FOOTER //
// ./src/pages/receiptsandcollections/components/ReceiptsAndCollectionsReportForm.js